var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12C22.5 17.5228 18.0228 22 12.5 22M22.5 12C22.5 6.47715 18.0228 2 12.5 2M22.5 12H2.5M12.5 22C6.97715 22 2.5 17.5228 2.5 12M12.5 22C9.93223 19.3038 8.5 15.7233 8.5 12C8.5 8.27674 9.93223 4.69615 12.5 2M12.5 22C15.0678 19.3038 16.5 15.7233 16.5 12C16.5 8.27674 15.0678 4.69615 12.5 2M2.5 12C2.5 6.47715 6.97715 2 12.5 2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12C22.5 17.5228 18.0228 22 12.5 22M22.5 12C22.5 6.47715 18.0228 2 12.5 2M22.5 12H2.5M12.5 22C6.97715 22 2.5 17.5228 2.5 12M12.5 22C9.93223 19.3038 8.5 15.7233 8.5 12C8.5 8.27674 9.93223 4.69615 12.5 2M12.5 22C15.0678 19.3038 16.5 15.7233 16.5 12C16.5 8.27674 15.0678 4.69615 12.5 2M2.5 12C2.5 6.47715 6.97715 2 12.5 2",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/svg3.404cbdafebdf6f067387d7f63f0ebc7f.svg";
export { ForwardRef as ReactComponent };